import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
  button: {
    textTransform: 'none',
    fontWeight: 500,
  },
};
